module.exports = __webpack_public_path__ + "img/hover_documents_sheets_view.b04acc40.svg";